'use client';

import { useAtom } from 'jotai';
import { debugChatOpenAtom } from '../atoms/debugChatAtoms';
import { DebugChatPanel } from './DebugChatPanel';

/**
 * Debug chat panel widget — rendered in the bottom-left corner.
 * Open/close state is driven by debugChatOpenAtom so any component
 * (e.g. NeedHelpButton) can open it without prop drilling.
 *
 * Only rendered when NEXT_PUBLIC_DEBUG_CHAT_ENABLED=true.
 */
export function DebugChatWidget() {
  const [isOpen, setIsOpen] = useAtom(debugChatOpenAtom);

  if (process.env.NEXT_PUBLIC_DEBUG_CHAT_ENABLED !== 'true') {
    return null;
  }

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed bottom-12 left-4 z-[9999] h-[500px] w-[400px]">
      <DebugChatPanel onMinimize={() => setIsOpen(false)} />
    </div>
  );
}
